import React from 'react'

export const FacetLabelTooltipModal = (props) => {

  return (
    <div className="modal fade c-modal-style show facetTooltipLabel" id={`${props.facetLabelName}`} tabindex="-1" aria-labelledby="facetTooltipLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-lg-a">
        <div className="modal-content share-modal">
          <button type="button" class="btn-close" id="facetTooltipModalClose" data-bs-dismiss="modal" aria-label="Close"></button>
          <div className="modal-body mt-2">
            <div id="body" class="row" data-ss-variation-applied="0">
              <h1>{props.facetLabelName ? props.facetLabelName : ""}</h1>
              <p dangerouslySetInnerHTML={{ __html: props.facetLabelDes ? props.facetLabelDes : "" }}></p>
             </div>
          </div>
        </div>
      </div>
    </div>

  )
}
